<template>
  <div class="operation-report-show-body-header flex flex-col">
    <div class="first-row flex justify-between items-start col-gap-5">
      <div class="title aisea-text-24-400-dark-gray truncate">{{ title }}</div>
      <div class="action-area flex-shrink-0 ml-auto">
        <slot name="action-area"></slot>
      </div>
    </div>
    <div class="second-row flex justify-between items-start col-gap-5">
      <div class="sub-title aisea-text-16-400-dark-gray truncate">
        {{ subTitle }}
      </div>
      <div class="updated-at aisea-text-16-400-dark-gray flex-shrink-0">
        {{ updatedAt }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OperationReportShowBodyHeaderPresentational",
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    updatedAt: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.operation-report-show-body-header {
  // スクロール範囲の調整のため、heightとpadding-topを調整
  min-height: 130px; // すごく長い船舶名対策
  padding-top: 40px;
  background-color: $aisea-pure-white;

  row-gap: 5px;

  .first-row {
    height: 50px;
  }
  .title {
    line-height: 42px;
  }
  .sub-title.updated-at {
    height: 28px;
    line-height: 30px;
  }
}
</style>
